import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getFhirJsonForMyVotes = async (codeSystemId = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!codeSystemId) {
        console.log("no codeSystemId");
        return null;
    }
    console.log("CALLING SERVER with getfhirresource with justVotes = true");
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getfhirresource',
            "apiToken": apiToken,
            'resourceid': codeSystemId,
            'resourcetype': "CodeSystem",
            'justVotes': true,
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is an object with {
            //  'success': true, 'found': true, 'foi': resourceId,
            //   'fhirjsonstring': data.toolstatestring, 'title': title, 'status': status,
            //   'loggedin': loggedin, 'readpermission': true, 'editpermission': editpermission,
            //  'adminpermission': adminpermission, "resourcetype": resourceTypeFound,
            //   "commentsdict": {}, "votesdict": {}, "myvotesdict": {}    }

            return resp.data;
        }
        console.log("NO RESPONSE from getfhirresource call with justVotes = true");
    }).catch((error) => { console.log(error); });
};

export default getFhirJsonForMyVotes;